import React from 'react';
import { Box, FormControl, FormLabel, Flex, Text, Spinner } from '@chakra-ui/react';
import CustomModal from '../common/CustomModal';
import Rating from '../common/Rating';
import { AdminReview } from '@/services/reviews/types';

interface ViewTestimonialModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTestimonial: AdminReview | null;
  isLoading?: boolean;
}

const ViewReviewModal: React.FC<ViewTestimonialModalProps> = ({
  isOpen,
  onClose,
  selectedTestimonial,
  isLoading,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title="Review Detail"
      showCloseButton={true}
      size="2xl"
    >
      {isLoading ? (
        <Flex justify="center" align="center" minH="200px">
          <Spinner size="lg" />
        </Flex>
      ) : selectedTestimonial ? (
        <Box display="flex" flexWrap="wrap">
          <FormControl mb={4} width="50%">
            <FormLabel
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="12px"
              lineHeight="18px"
              letterSpacing="0%"
              color="#4A5769"
            >
              Vendor/Logistics Name
            </FormLabel>
            <Text
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="14px"
              lineHeight="20px"
              letterSpacing="0%"
              color="#090F1A"
              whiteSpace="pre-wrap"
            >
              {selectedTestimonial.vendor?.company_name ||
                selectedTestimonial.logistics?.store_name ||
                'N/A'}
            </Text>
          </FormControl>
          <FormControl mb={4} width="50%">
            <FormLabel
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="12px"
              lineHeight="18px"
              letterSpacing="0%"
              color="#4A5769"
            >
              Reviewer Name
            </FormLabel>
            <Text
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="14px"
              lineHeight="20px"
              letterSpacing="0%"
              color="#090F1A"
              whiteSpace="pre-wrap"
            >
              {selectedTestimonial.reviewer_name}
            </Text>
          </FormControl>
          <FormControl mb={4} width="50%">
            <FormLabel
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="12px"
              lineHeight="18px"
              letterSpacing="0%"
              color="#4A5769"
            >
              Average Rating
            </FormLabel>
            <Rating
              initialRating={Number(selectedTestimonial.rating) || 0}
              boxSize="5"
              readOnly={true}
            />
          </FormControl>
          <FormControl mb={4} width="50%">
            <FormLabel
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="12px"
              lineHeight="18px"
              letterSpacing="0%"
              color="#4A5769"
            >
              Date of review
            </FormLabel>
            <Flex align="center" gap={1}>
              <Text
                fontFamily="Josefin Sans"
                fontWeight={400}
                fontStyle="normal"
                fontSize="14px"
                lineHeight="20px"
                letterSpacing="0%"
                color="#090F1A"
                whiteSpace="pre-wrap"
              >
                {selectedTestimonial.updated_at}
              </Text>
            </Flex>
          </FormControl>
          <FormControl mb={4} width="100%">
            <FormLabel
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="12px"
              lineHeight="18px"
              letterSpacing="0%"
              color="#4A5769"
            >
              Comment
            </FormLabel>
            <Text
              fontFamily="Josefin Sans"
              fontWeight={400}
              fontStyle="normal"
              fontSize="14px"
              lineHeight="20px"
              letterSpacing="0%"
              color="#090F1A"
              whiteSpace="pre-wrap"
            >
              {selectedTestimonial.content}
            </Text>
          </FormControl>
        </Box>
      ) : (
        <Text>No testimonial data available.</Text>
      )}
    </CustomModal>
  );
};

export default ViewReviewModal;
